import { createContext, MutableRefObject } from 'react';
import { EsriMapStore } from '../stores/esri-map-store';
import { MapView } from '../../esri/types';

export const MapGlobalContext = createContext<
    | {
          esriMapStore: EsriMapStore;
          esriMapViewRef: MutableRefObject<MapView | undefined>;
      }
    | undefined
>(undefined);
